import { render } from "./ProductIndex.vue?vue&type=template&id=4bc26bd8&ts=true"
import script from "./ProductIndex.vue?vue&type=script&lang=ts"
export * from "./ProductIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__